import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import Uploading from '@/Common/Uploading/Uploading'

import {
  TableRowWrapper,
  PurchasedDate,
  Description,
  TotalCostContainer,
  PaymentMethod,
  Status,
  Receipt,
  Currency,
  TotalCost,
  CancelOrRefund
} from "./TableRow.style";
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { mode } from "webconfig";
import OneBtnDialog from '../../../../Common/OneBtnDialog/OneBtnDialog';
import Notice from '../../Payment/Notice/Notice'
import i18n from '../../../../i18n';
// import ReactGA from 'react-ga';
// import ReactPixel from 'react-facebook-pixel';
const currencyTable = {
  KRW: "₩",
  JPY: "¥",
  USD: "$",
  VND: "₫",
  THB: "฿",
  IDR: "Rp"
};

export class TableRow extends Component {
  state = {
    cancle : false,
    failCancle : false,
    isdialogopened : false,
    dialogType : "refund",
    isRefunding: false,
    isUnscheduling: false,

    isNoticeOpened: false,
    active: false,
    refundReason: ''
  }
  

  handleNoticeClose = () => this.setState({ isNoticeOpened: false })
  
  checkUserWrited = (text) => {
    if (text.length > 1) {
      this.setState({
        active: true
      })
    } else {
      this.setState({
        active: false
      })
    }
  }

  sendGARefundEvent =  (paymentId) => {
    if (mode === 'stage') {
      // ReactGA.plugin.execute('ec', 'setAction', 'refund', {
      //   id: paymentId
      // })
      // ReactPixel.trackCustom("refund", {
      //   content_type: 'product',
      //   contents: [{ id: productInfo.productId, paymentId, quantity: 1 }]
      // })
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'tag_transaction',
          ecommerce: {
            refund: {
              actionField: { id: paymentId }
            }
          }
        })
      }
    }
  }

  onRefundReasonChanged = e => {
    this.checkUserWrited(e.target.value)
    this.setState({ refundReason: e.target.value })
  }

  openDiaogRefund = pgType => e => {
    if (pgType === 'IAP_google') return alert(i18n.t("tablerow.refund.googleplay"))
    if (pgType === 'IAP_apple') return alert(i18n.t("tablerow.refund.appstore"))

    this.setState({
      isNoticeOpened : true,
      paymentWay : "refund"
    })
  }

  onClickRefund = async () => {
    if (this.state.active && window.confirm(i18n.t("tablerow.ask.refund.text"))) {
      this.setState({ isNoticeOpened: false })
      const { _id: paymentId } = this.props.payment
      this.cancelPayment(paymentId, this.state.refundReason)
    }
  }

  cancelPayment = async (paymentId, reason) => {
    this.setState({ isRefunding: true })

    const token = localStorage.getItem("token")
    const cancelPaymentResult = await axios.patch(
      `${GetBaseUrl()}/apis/payments/refund`,
      { paymentId, reason },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .catch(err => {
      this.setState({
        isdialogopened : true,
        dialogType : "failRefund",
        isRefunding: false
      })
    })

    if (cancelPaymentResult && cancelPaymentResult.status === 200) {
      this.sendGARefundEvent(paymentId)
      alert(i18n.t("payment.success.refund.text"))
      this.setState({ isRefunding: false })
      if (this.props.refreshUserData) this.props.refreshUserData()
      else this.props.history.push({ pathname: '/home' })
    } else {
      this.setState({
        isdialogopened : true,
        dialogType : "failRefund",
        isRefunding: false
      })
    }
  }

  getReceipt = (paymentId, pgType) => async e => {
    const token = localStorage.getItem("token")
    if(this.props.payment.type === "PerPaymentWithCoupon"){
      // alert("쿠폰 결제로 인한 결제는 영수증 발급이 되지 않습니다.");
      this.setState({
        isdialogopened : true,
        dialogType : "refuseCouponRefund"
      })
      return
    }

    let getReceiptResult = null

    switch (pgType) {
      case `payple`:
        getReceiptResult = await axios.post(
          `${GetBaseUrl()}/api/payment/payple/getReceiptByPaymentId`,
          { paymentId },
          { headers: { Authorization: `Bearer ${token}` } }
        ).catch(error => {
          this.setState({ isdialogopened : true, dialogType : "errorRefund" })
        })
        break

      case 'naverpay':
        alert('네이버페이 홈페이지(https://order.pay.naver.com/home) > 결제상세정보 내역에서 영수증 확인가능합니다')
        return

      case 'paypal':
        alert(i18n.t("tablerow.alert.receipt.paypal"))
        return

      default:
        getReceiptResult = await axios.get(
          `${GetBaseUrl()}/apis/payments/${paymentId}/receipt`,
          { headers: { Authorization: `Bearer ${token}` } }
        ).catch(error => {
          this.setState({ isdialogopened : true, dialogType : "errorRefund" })
        })
        break
    }

    if (getReceiptResult && getReceiptResult.status === 200 && getReceiptResult.data && getReceiptResult.data.data) {
      const windowInnerWidth = window.innerWidth || 0;
      const windowInnerHeight = window.innerHeight || 0;
      const windowPopupWidth = 420;
      const windowPopupHeight = 800;
      const windowPopupLeft =
        windowInnerWidth > windowPopupWidth
          ? Math.floor((windowInnerWidth - windowPopupWidth) / 2)
          : 0;
      const windowPopupTop =
        windowInnerHeight > windowPopupHeight
          ? Math.floor((windowInnerHeight - windowPopupHeight) / 2)
          : 0;

      const windowPopupSpecs = 
        `width=${windowPopupWidth},` +
        `height=${windowPopupHeight},` +
        `left=${windowPopupLeft},` +
        `top=${windowPopupTop}`

      window.open(
        getReceiptResult.data.data.receiptUrl,
        '_blank',
        windowPopupSpecs
      );

    } else {
      alert(
        i18n.t("tablerow.alert.fail.receipt1_1") +
        i18n.t("tablerow.alert.fail.receipt1_2")
      );
    }
  }

  renderPaymentMethod = (type, cardName) => {
    if (type === 'PerPaymentWithCoupon' || type === 'SubscriptionPaymentWithCoupon') {
      return i18n.t("tablerow.coupon.text")
    }

    return cardName 
  }

  handleClose = () => this.setState({ isdialogopened : false })
 
  render() {
    const { _id: paymentId, confirmedAt, productInfo: { shortName }, amount, currency, type, isRefunded, isRefundable, pgType } = this.props.payment;
    const productName = shortName[this.props.value] || shortName['en']
    const refinedDate = dayjs(confirmedAt).utc().format("YY.MM.DD");
    const isIAP = pgType === 'IAP_google' || pgType === 'IAP_apple' 
  
    let status = i18n.t("tablerow.status.used")

    if (isRefunded) {
      status = i18n.t("tablerow.status.canceled")
    }

    return (
      <TableRowWrapper>
      < Uploading open={this.state.isRefunding} progress={0}>{i18n.t("tablerow.ing.refund")}</Uploading>
      < Uploading open={this.state.isUnscheduling} progress={0}>{i18n.t("tablerow.ing.cancel")}</Uploading>

        <PurchasedDate>{refinedDate}</PurchasedDate>
        <Description>{productName}</Description>
        <TotalCostContainer>
          <Currency>{currencyTable[currency]}</Currency>
          <TotalCost>{amount}</TotalCost>
        </TotalCostContainer>
        <Status>{status}</Status>
        {pgType === 'others' || isIAP
          ? <Receipt isHidden={true} >{i18n.t("orderhistory.header.title5")}</Receipt>
          : <Receipt onClick={this.getReceipt(paymentId, pgType)}>{i18n.t("orderhistory.header.title5")}</Receipt>
        }
        {(pgType === 'IAP_google' || type === 'PerPayment') && isRefundable ? (
          <CancelOrRefund onClick={this.openDiaogRefund(pgType)}>
            {i18n.t("tablerow.cancel.refund.text")}
          </CancelOrRefund>
        ) : (
          <CancelOrRefund isHidden={true}>
            {i18n.t("tablerow.cancel.refund.text")}
          </CancelOrRefund>
        )} 
         <OneBtnDialog
          open = {this.state.isdialogopened}
          dialogType = {this.state.dialogType}
          closeBtn = {this.handleClose}
          onButtonClick = {this.handleClose}
        />

        <Notice
          open={this.state.isNoticeOpened}
          closeBtn={this.handleNoticeClose}
          paymentWay='refund'
          onClickRefund={this.onClickRefund}
          checkUserWrited={this.checkUserWrited}
          active={this.state.active}
          refundReason={this.state.refundReason}
          onRefundReasonChanged={this.onRefundReasonChanged}
        />
      </TableRowWrapper>
    );
  }
}
